import { color, font, query, space } from '@design/templateFns';
import styled, { css } from 'styled-components';

/*** FILTER BUTTONS */
// FilterButton
export const ButtonContainer = styled.div`
  display: flex;
  overflow: visible;
`;

export const FButtonWrapper = styled.div<{ $allFilters: boolean }>`
  position: ${({ $allFilters }) => ($allFilters ? 'initial' : 'relative')};
`;

export const FButton = styled.button<{ $selected: boolean; $all: boolean }>`
  color: ${color('gray4')};
  ${font('subhead-xs')}
  padding: ${space('sm')} ${space('md')};
  cursor: pointer;
  border: 1px solid ${color('gray2')};
  border-radius: 4px;
  background: ${({ $selected }) => ($selected ? color('gray1')() : 'transparent')};
  margin-right: ${space('md')};
  display: ${({ $all }) => ($all ? 'flex' : 'none')};
  align-items: center;
  white-space: nowrap;

  &::last-child {
    margin-right: 0;
  }

  @media screen and (${query.atLeast('desktop')}) {
    display: flex;
    ${font('subhead-sm')}
  }

  &:hover,
  &:active {
    background: ${color('gray1')};
  }
`;

export const ButtonIcon = styled.div`
  width: 14px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-left: 14px;

  span {
    height: 2px;
    width: 8px;
    background-color: ${color('gray4')};
  }

  &:before {
    width: 14px;
    position: absolute;
    content: '';
    height: 2px;
    background-color: ${color('gray4')};
    top: 0;
  }

  &:after {
    width: 4px;
    position: absolute;
    content: '';
    height: 2px;
    background-color: ${color('gray4')};
    bottom: 0;
  }
`;

/*** FILTER MODALS */
// Modal General Styling

export const FModalWrapper = styled.div<{ $open: boolean }>`
  position: absolute;
  top: calc(100% + ${space('xl')});
  left: -${space('xl')};
  width: 100%;
  min-width: 348px;
  min-height: 100%;
  box-shadow: 2px 4px 15px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 4px 4px;
  padding: ${space('xl')};
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
  background-color: ${color('bg')};
  display: ${({ $open }) => ($open ? 'none' : '')};
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalSection = styled.div`
  margin: 0 0 ${space('lg')} 0;
`;

export const FModalWrapperAllFilters = styled(FModalWrapper)<{
  $selected: boolean;
}>`
  position: fixed;
  max-width: 348px;
  top: 0;
  left: unset;
  overflow-y: scroll;
  bottom: 0;
  height: 100vh;
  right: ${({ $selected }) => ($selected ? '0px' : '-348px')};
  transition:
    right 0.3s ease,
    box-shadow 0.3s ease;
  box-shadow: ${({ $selected }) => ($selected ? '2px 4px 15px rgba(0, 0, 0, 0.1)' : 'none')};
  display: none;
  z-index: 100;
  @media screen and (${query.atLeast('desktop')}) {
    display: block;
  }
`;

export const FModalWrapperAllFiltersMobile = styled.div`
  display: block;
  width: 95%;

  @media screen and (${query.atLeast('desktop')}) {
    display: none;
  }
`;

export const ModalHeader = styled.h5`
  color: ${color('fg')};
  margin: 0;
  ${font('body-md')}
  padding-bottom: 0;
  margin-bottom: ${space('xs')};
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
`;

export const ModalButton = styled.button`
  padding: ${space('sm')} ${space('md')};
  cursor: pointer;
  color: ${color('bg')};
  background-color: ${color('fg')};
  border: 1px solid transparent;
  border-radius: 4px;
  ${font('subhead-sm')}
`;

export const ModalButtonSecond = styled(ModalButton)`
  color: ${color('fg')};
  background-color: ${color('bg')};
  border-color: ${color('fg')};
  margin-left: ${space('md')};
`;

// Buy/Rent Tab
export const BuyRentWrapper = styled.div`
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: ${space('lg')};

  ${font('eyebrow-sm')}
`;

export const BuyRentInnerWrapper = styled.div`
  background-color: ${color('gray4')};
  border-radius: 6px;
  display: inline-block;
  border: 1px solid ${color('gray2')};
`;

export const TabButton = styled.button<{ $active: boolean }>`
  border: none;
  text-transform: uppercase;
  text-decoration: none;
  letter-spacing: 10%;
  background-color: transparent;
  color: ${color('bg')};
  cursor: pointer;
  padding: ${space('sm')} ${space('md')};
  font-weight: 700;

  ${({ $active }) =>
    $active &&
    css`
      background-color: ${color('gray1')};
      color: ${color('gray5')};
      border-radius: 4px;

      @media screen and (${query.atLeast('desktop')}) {
        border-radius: 4px;
      }
    `}
`;

export const SearchTypeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: ${space('sm')};
  grid-column-gap: ${space('md')};
`;

export const SearchType = styled.div<{ $selected: boolean }>`
  color: ${({ $selected }) => ($selected ? color('fg') : color('gray4'))};
  display: flex;
  align-items: flex-start;
  cursor: pointer;
`;

export const SearchTypesCheckLabel = styled.label`
  flex: 1 0 0%;
  width: 100%;
  ${font('body-md-light')}
  line-height: 1.1;
`;

export const SearchTypesCheck = styled.input`
  flex: 0 0 auto;
  width: ${space('lg')};
  height: ${space('lg')};
  border: 1px solid ${color('gray2')};
  border-radius: ${space('xs')};
  cursor: pointer;
  margin-right: ${space('sm')};

  appearance: none;
  background-color: ${color('bg')};
  margin: 3px ${space('sm')} 0 0;
  font: inherit;
  color: currentColor;
  transform: translateY(-0.075em);
  position: relative;

  &::before {
    // checkmark icon
    content: '';
    transform: scale(0) translate(-50%, -50%) rotate(45deg);
    width: 7px;
    height: 12px;
    border-right: 2px solid ${color('fg')};
    border-bottom: 2px solid ${color('fg')};
    background-color: rgba(255, 255, 255, 0.2);
    display: block;
    top: 45%;
    left: 60%;
    position: absolute;
    transform-origin: right;
  }

  &:checked::before {
    transform: scale(1) translate(-50%, -50%) rotate(45deg);
  }
`;

/*** ALL FILTERS */
export const AllFiltersWrapper = styled.div`
  background: ${color('bg')};
  padding: 0 ${space('xl')};
  position: relative;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
  flex: 1;

  @media screen and (${query.atLeast('tablet')}) {
    padding: 0 ${space('x8')};
  }
`;

export const SecondHeader = styled.h5`
  margin: 0 0 ${space('lg')} 0;
  padding: 0;
  ${font('headline-xxxs')}
`;

export const ButtonContainerFixed = styled.div`
  position: fixed;
  bottom: 0;
  width: calc(100% - 63px);
  background: ${color('bg')};
  box-shadow: 0px -4px 4px 0px rgb(0 0 0 / 8%);
  padding: ${space('md')};

  box-sizing: border-box;

  @media screen and (${query.atLeast('desktop')}) {
    margin-left: -${space('md')};
    width: 348px;
    padding: ${space('lg')};
  }
`;

export const ModalButtonWrapperFixed = styled(ModalButtonWrapper)`
  width: 100%;
  justify-content: center;
  flex-direction: column;

  @media screen and (${query.atLeast('desktop')}) {
    flex-direction: row;
  }
`;

export const ModalButtonFixed = styled(ModalButton)`
  padding: ${space('sm')} ${space('x5')};

  @media screen and (${query.below('desktop')}) {
    margin: 0 0 ${space('md')};
    width: 100%;
  }
`;

export const ModalButtonSecondFixed = styled(ModalButtonSecond)`
  padding: ${space('sm')} ${space('x5')};

  @media screen and (${query.below('desktop')}) {
    margin: 0;
    width: 100%;
  }
`;
